import { useState } from "react";
import { supabase } from "../../lib/supabaseClient";
import { createSeedData } from "../../data/seedData";

const SEED_USERS = [
  { user_id: "u1", name: "Ahmed Hassan", email: "ahmed@ametal.com", role: "ceo", company_id: "c1" },
  { user_id: "u_coo", name: "Volkan Tegen", email: "volkan@ametal.com", role: "coo", company_id: "c1" },
  { user_id: "u2", name: "Omar Farouk", email: "omar@ametal.com", role: "pm", company_id: "c1" },
  { user_id: "u3", name: "Fatima Ali", email: "fatima@ametal.com", role: "procurement", company_id: "c1" },
  { user_id: "u4", name: "Ibrahim Musa", email: "ibrahim@ametal.com", role: "warehouse", company_id: "c1" },
  { user_id: "u5", name: "Amina Yusuf", email: "amina@ametal.com", role: "finance", company_id: "c1" },
  { user_id: "u6", name: "Khalid Osman", email: "khalid@ametal.com", role: "dataentry", company_id: "c1" },
  { user_id: "pm_p2", name: "Karim Mansour", email: "karim@ametal.com", role: "pm", company_id: "c1" },
  { user_id: "pm_p3", name: "Nadia El-Amin", email: "nadia@ametal.com", role: "pm", company_id: "c1" },
  { user_id: "u_hr", name: "Layla Mahmoud", email: "layla@ametal.com", role: "hr", company_id: "c1" },
  { user_id: "sv_p1", name: "Mustafa Saleh", email: "mustafa@ametal.com", role: "supervisor", company_id: "c1" },
  { user_id: "sv_p2", name: "Youssef Bakr", email: "youssef@ametal.com", role: "supervisor", company_id: "c1" },
  { user_id: "sv_p3", name: "Tariq Nasser", email: "tariq@ametal.com", role: "supervisor", company_id: "c1" },
];

export function SeedPage() {
  const [log, setLog] = useState([]);
  const [running, setRunning] = useState(false);

  const addLog = (msg, type = "info") => setLog(prev => [...prev, { msg, type, ts: new Date().toLocaleTimeString() }]);

  const runSeed = async () => {
    setRunning(true);
    setLog([]);

    // Step 1: Register all users
    addLog("Creating Supabase auth users...");
    let successCount = 0;
    for (const u of SEED_USERS) {
      try {
        const { error } = await supabase.auth.signUp({
          email: u.email,
          password: "123456",
          options: {
            data: {
              app_user_id: u.user_id,
              company_id: u.company_id,
              role: u.role,
              display_name: u.name,
            },
          },
        });
        if (error) {
          if (error.message.includes("already registered")) {
            addLog(`  ${u.email} — already exists (OK)`, "warn");
            successCount++;
          } else {
            addLog(`  ${u.email} — ERROR: ${error.message}`, "error");
          }
        } else {
          addLog(`  ${u.email} — created`, "success");
          successCount++;
        }
      } catch (err) {
        addLog(`  ${u.email} — ERROR: ${err.message}`, "error");
      }
      // Small delay to avoid rate limits
      await new Promise(r => setTimeout(r, 300));
    }
    addLog(`Users done: ${successCount}/${SEED_USERS.length}`);

    // Step 2: Seed company data
    addLog("Seeding company data...");
    try {
      // Sign in as first user to have a session for RLS
      const { error: signInErr } = await supabase.auth.signInWithPassword({
        email: "ahmed@ametal.com",
        password: "123456",
      });
      if (signInErr) {
        addLog(`Sign-in failed: ${signInErr.message}`, "error");
        setRunning(false);
        return;
      }

      const seedData = createSeedData();

      // Check if data already exists
      const { data: existing } = await supabase
        .from("app_data")
        .select("id")
        .eq("company_id", "c1")
        .single();

      if (existing) {
        addLog("Company data already exists — updating...", "warn");
        const { error: updErr } = await supabase
          .from("app_data")
          .update({ data: seedData, data_version: 24 })
          .eq("company_id", "c1");
        if (updErr) addLog(`Update error: ${updErr.message}`, "error");
        else addLog("Company data updated!", "success");
      } else {
        const { error: insErr } = await supabase
          .from("app_data")
          .insert({ company_id: "c1", data: seedData, data_version: 24 });
        if (insErr) addLog(`Insert error: ${insErr.message}`, "error");
        else addLog("Company data inserted!", "success");
      }
    } catch (err) {
      addLog(`Seed data error: ${err.message}`, "error");
    }

    addLog("=== SEED COMPLETE ===", "success");
    addLog("You can now sign in with any user email + password '123456'");
    setRunning(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0a0c10", color: "#fff", fontFamily: "'DM Sans', sans-serif", padding: 40 }}>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Supabase Setup</h1>
        <p style={{ color: "rgba(255,255,255,0.4)", marginBottom: 24 }}>
          This page creates all demo users in Supabase Auth and seeds the company data.
          <br />Run this once after setting up your Supabase project.
        </p>

        <div style={{ marginBottom: 24, padding: 16, background: "rgba(234,179,8,0.08)", border: "1px solid rgba(234,179,8,0.2)", borderRadius: 12, fontSize: 13 }}>
          <strong style={{ color: "#eab308" }}>Before running:</strong>
          <ol style={{ margin: "8px 0 0 16px", color: "rgba(255,255,255,0.5)", lineHeight: 1.8 }}>
            <li>Run the SQL schema in Supabase Dashboard → SQL Editor (see <code>supabase-schema.sql</code>)</li>
            <li>Go to Authentication → Settings → uncheck "Enable email confirmations"</li>
          </ol>
        </div>

        <button
          onClick={runSeed}
          disabled={running}
          style={{
            padding: "14px 32px", borderRadius: 12, border: "none", cursor: running ? "wait" : "pointer",
            background: running ? "rgba(255,255,255,0.1)" : "linear-gradient(135deg, #0ea5e9, #2563eb)",
            color: "#fff", fontSize: 15, fontWeight: 600, fontFamily: "inherit",
            boxShadow: running ? "none" : "0 4px 24px rgba(14,165,233,0.3)",
          }}
        >
          {running ? "Running..." : "Run Seed"}
        </button>

        {log.length > 0 && (
          <div style={{ marginTop: 24, background: "#12151a", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 16, maxHeight: 500, overflowY: "auto", fontFamily: "'JetBrains Mono', monospace", fontSize: 12, lineHeight: 1.8 }}>
            {log.map((l, i) => (
              <div key={i} style={{ color: l.type === "error" ? "#ef4444" : l.type === "success" ? "#34d399" : l.type === "warn" ? "#eab308" : "rgba(255,255,255,0.5)" }}>
                <span style={{ color: "rgba(255,255,255,0.2)" }}>[{l.ts}]</span> {l.msg}
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: 32, fontSize: 13, color: "rgba(255,255,255,0.3)" }}>
          After seeding, go to <a href="/" style={{ color: "#38bdf8" }}>the app</a> and sign in.
        </div>
      </div>
    </div>
  );
}
